import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video", "overlay", "btn"]

  connect() {
    this.hasPlayed = false

    this.video = this.videoTarget
    this.overlay = this.overlayTarget
    this.btn = this.btnTarget

    this.video.addEventListener("play", () => this.onPlay())
    this.video.addEventListener("pause", () => this.showOverlay())
    this.video.addEventListener("ended", () => this.showOverlay())
  }

  play() {
    this.video.play()
  }

  onPlay() {
    if (!this.hasPlayed) {
      this.hasPlayed = true
      this.video.controls = true
      this.overlay.style.pointerEvents = "none"
      this.overlay.style.cursor = "default"
    }
    this.hideOverlay()
  }

  showOverlay() {
    this.btn.style.transform = "scale(0.7)"
    this.btn.style.opacity = "0"
    requestAnimationFrame(() => {
      this.btn.style.transition = "transform 0.25s cubic-bezier(0.34,1.56,0.64,1), opacity 0.2s ease"
      this.btn.style.transform = "scale(1)"
      this.btn.style.opacity = "1"
    })
    this.overlay.style.opacity = "1"
  }

  hideOverlay() {
    this.overlay.style.opacity = "0"
  }
}
